/**
 * Por que o curso existe, e o que e HCRM.
 *
 * Ate 19/10 estes dois blocos eram buraco marcado em ambar na tela, esperando
 * texto do grupo. O roteiro trouxe os dois, e os buracos saem.
 *
 * O enquadramento aqui e deliberado e vale preservar em qualquer reescrita: o
 * problema nao e falta de competencia tecnica, e a pergunta nao culpa ninguem.
 * O publico e quem vive a cena, e texto que soa a acusacao fecha a leitura no
 * primeiro paragrafo.
 */

export const problema = {
  pergunta:
    'Como uma equipe tecnicamente competente pode chegar a um resultado que ninguém queria?',
  contexto:
    'Em ambientes hospitalares complexos, eventos críticos nem sempre acontecem por falta de conhecimento técnico.',
  /* A cena, em fragmentos curtos de proposito: cada um e reconhecivel sozinho. */
  cena: [
    'Uma informação que não chega.',
    'Uma preocupação que não é verbalizada.',
    'Uma hierarquia que dificulta o questionamento.',
    'Mudanças no cenário que passam despercebidas.',
    'Decisões tomadas com informação incompleta e sob pressão.',
  ],
  remate:
    'É nesse espaço entre competência técnica e desempenho da equipe que o HCRM atua.',
} as const;

export const oQueE = {
  titulo: 'O que é HCRM',
  definicao:
    'Healthcare Crew Resource Management é a aplicação dos princípios de fatores humanos e gerenciamento de recursos de equipe ao contexto da saúde.',
  objetivo:
    'O objetivo não é eliminar o erro humano. É construir equipes e sistemas mais capazes de antecipar riscos, reconhecer mudanças, comunicar preocupações e responder ao\u00a0inesperado.',
  consequencia:
    'Comunicação, liderança, consciência situacional, suporte mútuo e tomada de decisão deixam de ser conceitos abstratos e passam a ser comportamentos que podem ser aprendidos, praticados e aprimorados.',
  remate:
    'Segurança não depende apenas de bons profissionais. Depende também de como bons profissionais trabalham juntos.',
} as const;
